import { render, staticRenderFns } from "./rulist.vue?vue&type=template&id=550660c2&scoped=true&"
import script from "./rulist.vue?vue&type=script&lang=js&"
export * from "./rulist.vue?vue&type=script&lang=js&"
import style0 from "./rulist.vue?vue&type=style&index=0&id=550660c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550660c2",
  null
  
)

export default component.exports